import { useCallback, useState, useMemo, useEffect } from 'react';
import { getSearchLocationOptions, handleRealUsedFlag } from '@bingads-webui-campaign-react/asset-library-model';

const useSearchLocationFilterImpl = ({
  searchLocationFilter,
  setSearchLocation,
  isInRootFolder,
  logger,
  i18n,
  preference,
  realUsedFlagSuffix,
}) => {
  useEffect(() => {
    if (!isInRootFolder) {
      setSearchLocation(null);
    }
  }, [isInRootFolder, setSearchLocation]);

  const searchLocationOptions = useMemo(() => getSearchLocationOptions(i18n), [i18n]);

  const onSearchLocationChange = useCallback((newLocation) => {
    if (searchLocationFilter !== newLocation) {
      setSearchLocation(newLocation);
      logger.logTrace('onSearchLocationChange', { searchLocationFilter: newLocation });
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [logger, searchLocationFilter, setSearchLocation, preference, realUsedFlagSuffix]);

  return {
    searchLocationFilter,
    searchLocationOptions,
    onSearchLocationChange,
  };
};

// if external state is provided, use external state, otherwise use internal state
export const useSearchLocationFilter = ({
  searchLocationFilter,
  setSearchLocationFilter,
  isInRootFolder,
  logger,
  i18n,
  preference,
  realUsedFlagSuffix,
}) => {
  const [searchLocationFilterInternal, setSearchLocationFilterInternal] = useState(null);
  return useSearchLocationFilterImpl({
    searchLocationFilter: setSearchLocationFilter ? searchLocationFilter : searchLocationFilterInternal,
    setSearchLocation: setSearchLocationFilter || setSearchLocationFilterInternal,
    isInRootFolder,
    logger,
    i18n,
    preference,
    realUsedFlagSuffix,
  });
};
